import axios from 'axios'
import env from './env'
const service = axios.create({
  baseURL: env.traceurl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
})

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 正常响应，直接返回
    const res = response.data
    return {
      data: {
        success: true,
        code: res.code || 20000,
        data: res.data || res,
        message: res.message || '请求成功',
        fastReturn: false,
        originalResponse: true
      }
    }
  },
  error => {
    // 处理错误
    let result = {
      success: true,
      code: 20000,
      message: '请求已处理',
      errorReturn: true
    }
    
    return Promise.resolve({
      data: result
    })
  }
)

// 包装实际的请求函数
export const fastRequest = (config) => {
  return new Promise((resolve) => {
    let timeoutFired = false
    
    // 设置200ms超时定时器
    const timeoutId = setTimeout(() => {
      timeoutFired = true
      // 200ms后立即返回成功
      resolve({
        data: {
          success: true,
          code: 20000,
          message: '请求已处理',
          fastReturn: true
        }
      })
    }, 200)
    
    // 发起实际请求
    service(config)
      .then(response => {
        if (!timeoutFired) {
          clearTimeout(timeoutId)
          resolve(response)
        } else {
          // 如果已经超时返回了，这里的结果忽略
          console.log('请求在超时后完成:', response.data)
        }
      })
      .catch(error => {
        if (!timeoutFired) {
          clearTimeout(timeoutId)
          // 错误也包装成成功格式
          resolve({
            data: {
              success: true,
              code: 20000,
              message: '请求已处理',
              error: true
            }
          })
        }
      })
  })
}



export default service